import { get, post, put, del } from './client';

export const getUsers = () => get('/api/users');

export const getUser = (userId) => get(`/api/users/${userId}`);

export const createUser = (userData) => post('/api/users', userData);

export const updateUser = (userId, userData) => put(`/api/users/${userId}`, userData);

export const deleteUser = (userId) => del(`/api/users/${userId}`);
